module.exports = __webpack_public_path__ + "./fonts/CitrusGothic-Regular.ttf";